import React from 'react';
import { useState } from 'react';
import TXlogo from '../assets/TXlogo.jpg';
import NABHlogo from '../assets/NABHlogo.jpg';
import QAlogo from '../assets/QualityApprovallogo.jpg';
import { IoMdArrowDropdown } from "react-icons/io";
// import LanguageDropdown from './LanguageDropdown';
import NavBar from './Navigation';

const Header = () => {
  const [isLangDropdownOpen, setLangDropdownOpen] = useState(false);

  return (
    <header className="bg-white shadow-md">
      {/* <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-10"> */}
      <div className="container mx-auto flex justify-between items-center py-4 px-6">
       <img src={TXlogo} alt="TX Hospitals Logo" className="w-24 h-24 headerlogo" />

        {/* Language and Contact Section */}
        <div className="flex items-center space-x-6">
          {/* <div className="relative">
            <button
              onClick={() => setLangDropdownOpen(!isLangDropdownOpen)}
              className="text-gray-700 flex items-center space-x-1 focus:outline-none"
            >
              <span>English</span>
              <svg
                className="w-4 h-4 transform transition-transform duration-200"
                style={{ transform: isLangDropdownOpen ? 'rotate(180deg)' : 'rotate(0)' }}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            {isLangDropdownOpen && (
              <div className="absolute mt-2 w-32 bg-white border rounded shadow-lg z-50">
              <ul className="relative">
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">English</li>
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Arabic</li>
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Bengali</li>
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">French</li>
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Hindi</li>
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Telugu</li>
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Urdu</li>
              </ul>
            </div>            
            )}
          </div> */}
          <div className="relative group">
                        <button className="text-sm font-medium flex items-center">
                            English <IoMdArrowDropdown className="ml-1" />
                        </button>
                        <div className="absolute top-5 left-0 opacity-0 pointer-events-none transform scale-y-0 transition-all duration-300 group-hover:opacity-100 group-hover:scale-y-100 group-hover:pointer-events-auto bg-white shadow-md border border-gray-200 rounded-md w-36 origin-top z-20">
                            <ul className="text-sm">
                                <li className="p-2 hover:bg-gray-100 cursor-pointer">English</li>
                                <li className="p-2 hover:bg-gray-100 cursor-pointer">Telugu</li>
                                <li className="p-2 hover:bg-gray-100 cursor-pointer">Hindi</li>
                            </ul>
                        </div>
                    </div>
         {/*<LanguageDropdown />

        {/* Contact Details */}
        <div className="flex items-center space-x-6">
          {/* Emergency Contact */}
          <div className="flex flex-col items-center">
            <span className="font-semibold text-gray-700 text-sm">
              24/7 EMERGENCY CARE
            </span>
            <span className="text-pink-500 text-xl">
              <i className="fas fa-headset"></i>
              <a
              href="tel:+919089489089"
              className="text-sm text-blue-600 ml-2 font-medium hover:underline"
            >
              +91 9089 48 9089
            </a>
            </span>
          </div>

          <div className="border-l border-gray-300 h-10"></div>

          {/* International Contact */}
          <div className="flex flex-col items-center">
            <span className="font-semibold text-gray-700 text-sm">
              INTERNATIONAL
            </span>
            <a
              href="tel:+919089489089"
              className="text-sm text-blue-600 font-medium hover:underline"
            >
              +91 9089 48 9089
            </a>
          </div>
        </div>

          {/* Certifications */}
          <div className="flex space-x-2">
            <img
              src={NABHlogo}
              alt="NABH Certification"
              className="w-24 h-24 headerlogo"
            />
            <img
              src={QAlogo}
              alt="Quality Certification"
              className="w-24 h-24 headerlogo"
            />
          </div>
        </div>
      </div>
      <NavBar />
    </header>
  );
};

export default Header;
